import React from "react";
import { useTranslation } from "react-i18next";
import SEOHead from "../section/SeoHead";
import HeroSection from "../section/HeroSection";
import ReviewsSection from "../section/ReviewsSection";
import WhyChooseUsSection from "../section/WhyChooseUsSection";
import AboutUsSection from "../section/AboutUsSection";
import ServicesSection from "../section/ServicesSection";
import FaqSection from "../section/FaqSection";
import ContactSection from "../section/ContactSection";
import PlansSection from "../section/PlansSection";

export default function Home() {
  const { t } = useTranslation();
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Citizen Hub Immigration Services",
    description:
      "Professional immigration form assistance and legal services in the United States with expert guidance, lawyer matching, and direct payment processing.",
    url: "https://citizenhubimmigration.com",
    telephone: "+1 3108802133",
    email: "info@citznhub.com",
    openingHours: "Mo,Tu,We,Th,Fr,Sa,Su 00:00-23:59",
    priceRange: "$$",
    areaServed: ["United States", "California", "New York", "Texas", "Florida"],
  };

  return (
    <>
      <SEOHead
        title={t("home_page.seo.title")}
        description={t("home_page.seo.description")}
        keywords={t("home_page.seo.keywords")}
        canonicalUrl="https://citizenhubimmigration.com/"
        structuredData={structuredData}
      />
      <HeroSection />
      <ReviewsSection />
      <WhyChooseUsSection />
      <AboutUsSection />
      <ServicesSection />
      <PlansSection />
      <FaqSection />
      <ContactSection />
    </>
  );
}
